
////////////////////// forms ///////////////////////////////////////////

export const ADD_ORGANIZATION_PACKAGE_FORM_NAME = "OrganizationPackageMapping_Add_Form";

////////////////////// routes ///////////////////////////////////////////

export const organizationPackageMapping_getRoutePathStringForForNavigationContainer = (id ) => {
    return id? "/organizationPackageMapping/" + id : "/organizationPackageMapping";
};

export const organizationPackageMapping_getDetailIdFromPath = (locationReduxVariable) => {
    let url = locationReduxVariable.pathname;
    let match = url.match(new RegExp('organizationPackageMapping/([^/]+)'));
    if (match) {
        return match[1];
    }
    return false;
};

export const hasGenericOrganization = ( customPackageStruct ) => {
    return ! customPackageStruct.organizationIdentifier;
};


// WEBPACK FOOTER //
// ./src/Atollon/pages/OrganizationPackageMapping/shared.js